import { render, staticRenderFns } from "./noticeSwitch.vue?vue&type=template&id=9f4fbb0c&scoped=true"
import script from "./noticeSwitch.vue?vue&type=script&lang=js"
export * from "./noticeSwitch.vue?vue&type=script&lang=js"
import style0 from "./noticeSwitch.vue?vue&type=style&index=0&id=9f4fbb0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4fbb0c",
  null
  
)

export default component.exports